import { Button, Card, CardHeader, Fab } from '@mui/material';
import RecordList from 'components/RecordList';
import { withRouter } from 'components/shell/WithRouter';
import { Icons } from 'config/icons';
import { User } from 'firebase/auth';
import { isMobile } from 'helpers';
import React from 'react';
import { connect } from 'react-redux';
import { getUserPlaylists } from 'store/data/user/selectors';
import { ApplicationState, Article, ArticlesById, UserPlaylist, UserPlaylists } from 'types';
import UserPlaylistTile from './UserPlaylistTile';

const classes = {
	fab: (offset: number) => ({
		position: isMobile() ? 'fixed' : ('absolute' as 'fixed'),
		bottom: `${offset + (isMobile() ? 75 : 20)}px; bottom: calc(${offset + (isMobile() ? 75 : 20)}px + env(safe-area-inset-bottom)/2)`,
		right: 30,
		zIndex: 1,
		width: 150,
	}),
};

interface PlayListsProps {
	playlists: UserPlaylists;
	allArticles: ArticlesById;
	user?: User;
	history: any;
}

class UserPlaylistsControl extends React.Component<PlayListsProps, any> {
	private getItemSize = (index) => {
		return 93;
	};

	private getTracks = (playlist: UserPlaylist) => {
		let { allArticles } = this.props;

		let articles: Article[] = [];
		let tracks = Object.values(playlist.tracks).sort((a, b) => a.order - b.order);

		for (let i = 0; i < tracks.length; i++) {
			let href = tracks[i].articleId;
			if (allArticles[href]) {
				articles.push(allArticles[href]);
			}
		}

		return articles;
	};

	render() {
		let { playlists, user, history } = this.props;
		let navigate = history.navigate;

		if (!user) {
			return (
				<Card style={{ margin: 8 }}>
					<CardHeader
						subheader="Please signin to manage playlists"
						action={
							<Button
								style={{ marginTop: 8 }}
								size="small"
								onClick={() => {
									navigate('/account?screen=signin', { state: { isModal: true } });
								}}
							>
								Sign In
							</Button>
						}
					/>
				</Card>
			);
		}

		// delete playlists[0];
		let playlistsArray = Object.values(playlists).sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || (a.title < b.title ? -1 : 1));
		let hasMultiplePlaylists = playlistsArray.length > 1;

		return (
			<>
				{hasMultiplePlaylists && (
					<Fab
						color="primary"
						variant="extended"
						sx={classes.fab(10)}
						onClick={() => {
							navigate('/playlists/reorder', { state: { isModal: true } });
						}}
					>
						{Icons.SwapVert} &nbsp; Reorder
					</Fab>
				)}
				<RecordList
					records={playlistsArray}
					fetching={false}
					RecordTile={UserPlaylistTile}
					getItemSize={this.getItemSize}
					RecordTileProps={{ getTracks: this.getTracks }}
				/>
			</>
		);
	}
}

function mapStateToProps(state: ApplicationState) {
	return {
		playlists: getUserPlaylists(state),
		allArticles: state.dataState.articles.byId,
		user: state.userState.userStore.user,
	};
}

export default connect(mapStateToProps)(withRouter(UserPlaylistsControl));
